import React from 'react';
import PropTypes from 'prop-types';
import { DataCard, RadioButton } from 'anf-core-react';

export default function RadioExpansionCard({
  id,
  header,
  highlight = '',
  group,
  description,
  subText = '',
  children,
  isSelected,
  setSelected,
  dataTestId = 'test',
}) {
  return (
    <div data-testid={`radio-expansion-card-${dataTestId}`} className={`radio-expansion-card${isSelected ? ' active' : ''}`}>
      <DataCard
        headerContent={(
          <>
            {highlight && (
              <span data-testid={`highlight-text-${dataTestId}`} className="radio-expansion-card-highlight">
                <span className="radio-expansion-card-highlight-text">{highlight}</span>
              </span>
            )}
            <RadioButton
              id={id}
              label=""
              name={group}
              onChange={setSelected}
              value={id}
              isChecked={isSelected}
            />
          </>
        )}
        headerTitle={header}
        variant="boxed"
        theme="primary-light"
      >
        <div className="radio-expansion-card-content">
          <span className="left" data-testid={`description-${dataTestId}`}>{description}</span>
        </div>
        {isSelected && subText && (
          <p data-testid={`subtext-${dataTestId}`} className="radio-expansion-card-content-subtext">
            {subText}
          </p>
        )}
        {isSelected && children}
      </DataCard>
    </div>
  );
}

RadioExpansionCard.propTypes = {
  id: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  highlight: PropTypes.string,
  group: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  subText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isSelected: PropTypes.bool,
  setSelected: PropTypes.func,
  dataTestId: PropTypes.string,
};
